import { render, staticRenderFns } from "./LoaderPanel.vue?vue&type=template&id=35373bc6&scoped=true"
import script from "./LoaderPanel.vue?vue&type=script&lang=js"
export * from "./LoaderPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35373bc6",
  null
  
)

export default component.exports